import { render, staticRenderFns } from "./ProgramLimitHistoryItem.vue?vue&type=template&id=6b0a8360&scoped=true&"
import script from "./ProgramLimitHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ProgramLimitHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./ProgramLimitHistoryItem.vue?vue&type=style&index=0&id=6b0a8360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a8360",
  null
  
)

export default component.exports